import API from '../endpoints';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 5 minutes frontend cache for league table query
const CACHE_TIME = 5 * 60 * 1000;

export type LeagueTableQueryArgs = {
  teamId?: string;
  competitionId?: string;
};

type QueryOptions = {
  enabled: boolean;
};

export const useLeagueTableQuery = (args: LeagueTableQueryArgs, options?: QueryOptions) => {
  return useQuery({
    queryKey: ['league-table', args],
    queryFn: fetchLeagueTable,
    staleTime: !accessToken ? CACHE_TIME : undefined,
    ...(options ?? {}),
  });
};

const fetchLeagueTable: QueryFunction<any, [string, LeagueTableQueryArgs]> = async ({ queryKey }) => {
  const [, params] = queryKey;

  const { data } = await axios.get<any>(API.endpoints.leagueTable, {
    params,
  });
  return data;
};
